import React, { useState, useEffect, useContext } from 'react';
import PortalHeader from "../components/PortalHeader.js";
import '../styles/portal.css';
import CustomTextField from '../utils/custom_textfield.js';
import OtpInput from '../utils/otp_input.js';
import { Link, useNavigate } from 'react-router-dom'
import { AuthContext } from "../context/AuthContext.js";
import { DataContext } from "../context/DataContext.js";
import ApplicationCard from '../components/ApplicationCard.js';
import ApplicationForm from '../components/ApplicationForm.js';
import { buildUrlWithUTM, extractUTMParameters, storeUTMParameters, getStoredUTMParameters } from '../utils/utmUtils.js';

const PortalApplicationPage = () => {
    const [loading, setLoading] = useState(false);

    const authContext = useContext(AuthContext);
    const dataContext = useContext(AuthContext);
    const { getApplicationData, applicationData } = useContext(DataContext);  // Correctly access getApplicationData from DataContext

    const navigate = useNavigate();




    const handleLogout = () => {
        // Preserve UTM parameters before logout clears localStorage
        const currentUtmParams = extractUTMParameters();
        const storedUtmParams = getStoredUTMParameters();
        const utmParams = (currentUtmParams.utm_source || currentUtmParams.utm_medium || currentUtmParams.utm_campaign) 
          ? currentUtmParams 
          : storedUtmParams;

        console.log('Logout - Current UTM params:', currentUtmParams);
        console.log('Logout - Stored UTM params:', storedUtmParams);
        console.log('Logout - Using UTM params:', utmParams);

        setLoading(true);
        authContext.logout();
        console.log("Logout successfully");
        setLoading(false);
        
        // Build URL with UTM parameters directly
        let loginUrl = '/portal/login';
        if (utmParams.utm_source || utmParams.utm_medium || utmParams.utm_campaign) {
          const params = new URLSearchParams();
          if (utmParams.utm_source) params.append('utm_source', utmParams.utm_source);
          if (utmParams.utm_medium) params.append('utm_medium', utmParams.utm_medium);
          if (utmParams.utm_campaign) params.append('utm_campaign', utmParams.utm_campaign);
          loginUrl = `${loginUrl}?${params.toString()}`;
          
          // Restore UTM parameters to localStorage after logout so they persist on login page
          storeUTMParameters(utmParams);
        }
        
        console.log('Logout - Navigating to:', loginUrl);
        // Use window.location.href to ensure URL is updated in browser
        window.location.href = loginUrl;
    }
   
    useEffect(() => {
        if (!authContext.loading) {
            if (!authContext.isAuthenticated) {
                navigate("/portal/login");
            }
        }
    }, [authContext.isAuthenticated, authContext.loading]);


    return (
        <>
            <PortalHeader >
                <nav className="nav-links">
                    <a href={buildUrlWithUTM("/portal")} className="nav-link" onClick={(e) => { e.preventDefault(); navigate(buildUrlWithUTM('/portal')); }}>Home</a>
                    <a href={buildUrlWithUTM("/portal/dashboard")} className="nav-link" onClick={(e) => { e.preventDefault(); navigate(buildUrlWithUTM('/portal/dashboard')); }}>Dashboard</a>
                </nav>
                <button className="logout-button" onClick={handleLogout}>Logout</button>
            </PortalHeader>
            <div className='application-form'>

                <ApplicationForm />

            </div>
        </>
    );
}

export default PortalApplicationPage;